.react-table-wrapper {
  width: 100%;
  border-collapse: collapse;
}

.react-table-header-row {
  font-size: var(--typography-label-font-size);
  line-height: var(--typography-label-line-height);
  font-weight: var(--font-weight-medium);
  margin: var(--space-0);
  padding: var(--space-0);
  background-color: var(--default--background-color--14);
}

.cell {
  display: flex;
  align-items: center;
  padding: var(--space-8) var(--space-16);
  overflow-wrap: anywhere;
}

.react-table-body-row {
  font-size: var(--typography-paragraph-font-size);
  line-height: var(--typography-paragraph-line-height);
  font-weight: var(--font-weight-normal);
  margin: var(--space-0);
  padding: var(--space-0);
  border-bottom: 1px solid var(--table--border-color--2);
}

.react-table-body-row:last-of-type {
  border-bottom: none;
}

.loading-indicator {
  min-height: 100px;
}

.sort-icon {
  margin-left: var(--space-8);
  height: 15px;
  width: 15px;
  color: var(--grey-400);
}

.sorted-sort-icon {
  margin-left: var(--space-8);
  height: 15px;
  width: 15px;
  color: var(--grey-400);
}
